import store from '@/store'
import interpolate from 'color-interpolate'
import gsap from 'gsap'
import { MotionPathPlugin } from 'gsap/MotionPathPlugin'
import { playUnlock } from '@/lib/sound.js'

gsap.registerPlugin(MotionPathPlugin)

let existing_anim = undefined
let animating_buttons = new Set()

const colourmap = interpolate(['#cdf4dd', '#468B18'])

function tripleclick(event) {
  console.log('tripleclick')
  mousedown(event)
}

function animateColour() {
  //const opacity = Math.min(animating_buttons.size * 0.2, 1)
  const opacity = Math.min(animating_buttons.size * 0.3 + 0.1, 1)

  return new Promise((resolve, reject) => {
    let anim_string = `${Date.now()} animating: ${[
      ...animating_buttons.values(),
    ]}`
    console.log('starting: ', anim_string)

    const anim = gsap.fromTo(
      [...animating_buttons.values()].map((r) => '#' + r),
      {
        //backgroundColor: `rgba(255,54,51,${opacity})`, //'#468B18',
        color: colourmap(opacity),
      },
      {
        //backgroundColor: 'rgba(255,54,51,0)',
        color: colourmap(0),
        duration: 1,
        ease: 'power4.in',
        onComplete: function () {
          console.log('onComplete: ', anim_string)
          animating_buttons.clear()
          //store.commit('SET_UNLOCK_PROGRESS', 0)
          unlockProgress.progress = 0
          store.commit('SET_BLOCK_CLICKS', [])
          resolve()
        },
      }
    )
    existing_anim = function () {
      console.log('killing: ', anim_string)
      anim.kill()
      reject()
    }
  })
}

function mousedown(event) {
  store.commit('SET_BLOCK_CLICKS', [4, 5, 6, 7, 8, 9])
  if (
    !animating_buttons.has(event.target.id) &&
    ['button-1', 'button-2', 'button-3'].includes(event.target.id)
  ) {
    animating_buttons.add(event.target.id)

    if (existing_anim) {
      existing_anim()
    }

    /*store.commit('TWEEN_UNLOCK_PROGRESS', {
      from: store.getters.unlockProgress,
      to: animating_buttons.size * (100 / 3),
    })*/
    tween_unlock_progress({
      from: (animating_buttons.size - 1) * (100 / 3),
      to: animating_buttons.size * (100 / 3),
      duration: 0.5,
    })

    if (
      ['button-1', 'button-2', 'button-3'].every((r) =>
        animating_buttons.has(r)
      )
    ) {
      triggered()
      return
    }

    Promise.all([animateColour()]).then(() => {
      console.log('then all')
      store.commit('SET_CODE_SCREEN', 'CodeScreenBase')
    })
  }
}

const unlockProgress = {
  _progress: 0,
  set progress(val) {
    store.commit('SET_UNLOCK_PROGRESS', +val)
    this._progress = +val
    console.log('tweened to:', +val)
  },
  get progress() {
    return this._progress
  },
}

function tween_unlock_progress(vals) {
  console.log('tween_unlock_progress:', vals)
  console.log(unlockProgress.progress)
  gsap.to(unlockProgress, {
    progress: vals.to,
    duration: vals.duration,
  })
}

function triggered() {
  const one_button = document.getElementById('button-1')
  const two_button = document.getElementById('button-2')
  const three_button = document.getElementById('button-3')
  const one_pos = one_button.getBoundingClientRect()
  const two_pos = two_button.getBoundingClientRect()
  const three_pos = three_button.getBoundingClientRect()

  //store.commit('SET_UNLOCK_PROGRESS', 100)
  //unlockProgress.progress = 100
  setTimeout(() => {
    //store.commit('SET_UNLOCK_PROGRESS', 0)
    unlockProgress.progress = 0
  }, 800)

  store.commit('SET_BLOCK_CLICKS', [1, 2, 3, 4, 5, 6, 7, 8, 9])
  let unlocking = false

  if (!store.getters.isActionUnlocked('tripleclick')) {
    unlocking = true
    setTimeout(() => {
      playUnlock()
    }, 1000)
  } else {
    store.commit('SET_MOVE_NAME_ANIMATE', store.getters.actions['tripleclick'])
  }

  gsap.fromTo(
    [one_button, two_button, three_button],
    {
      //backgroundColor: `rgba(255,54,51,0.6)`, //'#468B18',
      color: colourmap(1),
    },
    {
      //backgroundColor: 'rgba(255,54,51,0)',
      color: colourmap(0),
      duration: 1,
      //delay: 2,
      delay: unlocking ? 2 : 1,
    }
  )

  setTimeout(
    () => {
      const tl = gsap.timeline()

      tl.fromTo(
        one_button,
        {
          scaleY: 1,
          transformOrigin: 'bottom',
        },
        {
          scaleY: 1.5,
          transformOrigin: 'bottom',
          duration: 0.1,
        },
        'jump'
      )

      tl.fromTo(
        one_button,
        {
          x: 0,
          y: 0,
        },
        {
          motionPath: {
            path: [
              { x: (three_pos.x - one_pos.x) / 2, y: -200 },
              { x: three_pos.x - one_pos.x, y: 0 },
            ],
            curviness: 1,
          },
          ease: 'none',
          duration: 0.5,
        },
        'jump'
      )

      tl.fromTo(
        [two_button, three_button],
        {
          x: 0,
          y: 0,
        },
        {
          x: -(two_pos.x - one_pos.x),
          y: 0,
          duration: 0.4,
          delay: 0.1,
        },
        'jump'
      )

      tl.to(one_button, {
        scaleY: 1,
        transformOrigin: 'bottom',
        duration: 0.1,
        onComplete: () => {
          let new_vals = [...store.getters.button_vals]
          const old_one = new_vals[0]
          new_vals[0] = new_vals[1]
          new_vals[1] = new_vals[2]
          new_vals[2] = old_one
          store.commit('SET_BUTTON_VALS', new_vals)
          console.log('SET_BUTTON_VALS ', new_vals)
          animating_buttons.clear()
          tl.time(0)
          tl.kill()
          resetButtonStyle('button-1')
          resetButtonStyle('button-2')
          resetButtonStyle('button-3')
          if (!store.getters.isActionUnlocked('tripleclick')) {
            store.dispatch('unlock_action', 'tripleclick')
            setTimeout(() => {
              store.commit('SET_SHOW_UNLOCK_DIALOG', true)
            }, 500)
          } else {
            store.commit('SET_BLOCK_CLICKS', [])
          }
        },
      })
    },
    unlocking ? 2000 : 1000
  ) //2000)
}

function resetButtonStyle(button_id) {
  const button = document.getElementById(button_id)
  gsap.set(button, { clearProps: 'all' })
}

export default tripleclick
